class ColorVariants extends HTMLElement {
  constructor() {
    super();
    this.storeUrl = 'brok-bouwmaterialen.myshopify.com';
    this.variantTag = this.dataset.variantTag;
    this.variantType = this.dataset.variantType;
    this.carouselContainer = this.querySelector('.color__variants--list');
  }

  async connectedCallback() {
    if (!this.variantTag || !this.carouselContainer) {
      this.renderError('Variant tag or carousel container missing.');
      return;
    }

    this.renderLoading();

    try {
      const variants = await this.fetchColorVariants(this.variantTag);
      if (variants.length > 0) {
        this.renderVariants(variants);
        this.initializeColorCarousel();
      } else {
        this.renderError('No color variants found.');
      }
    } catch (error) {
      console.error('Error fetching color variants:', error);
      this.renderError('Error fetching color variants.');
    }
  }

  // Placeholder while loading
  renderLoading() {
    this.carouselContainer.innerHTML = `<li class="loading-placeholder">Loading color variants...</li>`;
  }

  async fetchColorVariants(tag) {
    try {
      console.log('Fetching variants for:', tag);
      const response = await fetch(
        `https://apps.shopmonkey.nl/brok-bouwmaterialen/api/color_variants/${encodeURIComponent(tag)}`,
        {
          method: 'GET',
          headers: {
            'Content-Type': 'application/json',
          },
        }
      );

      if (!response.ok) {
        throw new Error(`HTTP error! Status: ${response.status}`);
      }

      const data = await response.json();
      console.log('Fetched data:', data);

      return (
        data.data?.products?.edges.map(({ node }) => ({
          title: node.title,
          handle: node.handle,
          imageUrl: node.featuredImage?.url || '',
          altText: node.featuredImage?.altText || node.title,
          linkedVariantTitle: node.metafield?.value || '',
        })) || []
      );
    } catch (error) {
      console.error('Error fetching color variants:', error);
      return [];
    }
  }

  renderVariants(variants) {
    const currentUrl = window.location.pathname;
    const variantItems = variants
      .map((variant) => {
        const linkedVariantName = variant.linkedVariantTitle || '';
        const variantUrl = `/products/${variant.handle}`;
        const activeClass = currentUrl === variantUrl ? 'active' : '';

        if (this.variantType === 'images') {
          return `
            <li class="splide__slide color__variants--item ${activeClass}">
              <a href="${variantUrl}" title="${variant.title}">
                <img src="${variant.imageUrl}" alt="${variant.altText}" class="color__variants--item__image" />
                <span class="color__variants--item__title">${linkedVariantName}</span>
              </a>
            </li>
          `;
        } else if (this.variantType === 'variants') {
          return `
            <a href="${variantUrl}" title="${variant.title}" class="product__variants--list__item ${activeClass}" role="button">
                <span>${linkedVariantName}</span>
            </a>
          `;
        }
      })
      .join('');

    this.carouselContainer.innerHTML = variantItems;
  }

  renderError(message) {
    const errorElement = document.createElement('p');
    errorElement.className = 'color__variants--error';
    errorElement.textContent = message;
    this.appendChild(errorElement);
  }

  initializeColorCarousel() {
    const carousel = this.querySelector('.color__variants--carousel');
    if (carousel) {
      new Splide(carousel, {
        type: 'slide',
        autoWidth: true,
        gap: '8px',
        arrows: true,
        pagination: false,
        perPage: 8,
        breakpoints: {
          768: {
            perPage: 4,
          },
        },
      }).mount();
    }
  }
}

customElements.define('color-variants', ColorVariants);
